import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
import { CTAButton, SHOPIFY_URL } from './ui/CTAButton';
export function HeroSection() {
  return <section className="pt-20 pb-16 px-4 bg-white overflow-hidden" data-id="element-105">
      <div className="max-w-4xl mx-auto text-center" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center gap-2 bg-blue-50 text-blue-800 px-4 py-2 rounded-full text-sm md:text-base font-bold mb-6 border border-blue-200" data-id="element-107">
          <BookOpen className="w-5 h-5" data-id="element-108" />
          Para madres, padres, docentes y terapeutas (niños de 5 a 10 años)
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.1
      }} className="text-4xl md:text-6xl font-black text-gray-900 mb-6 tracking-tight" data-id="element-109">
          <span className="bg-yellow-200 px-2 leading-tight" data-id="element-110">MEGA KIT</span>
          <br data-id="element-111" />
          LECTOESCRITURA
        </motion.h1>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.15
      }} className="text-xl md:text-2xl text-gray-700 font-medium mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-112">
          El método imprimible paso a paso para que tu hijo{' '}
          <span className="bg-yellow-200 font-black px-1" data-id="element-113">
            lea, escriba y comprenda
          </span>{' '}
          con{' '}
          <span className="bg-yellow-200 font-black px-1" data-id="element-114">
            confianza en 30 días
          </span>
          .
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="mb-10" data-id="element-115">
          <a href={SHOPIFY_URL} className="block" data-id="element-116">
            <motion.img src="https://cdn.magicpatterns.com/uploads/4JvTEce4M32ELfHdtzC59T/1.png" alt="MEGA KIT LECTOESCRITURA - Lectura, Escritura, Comprensión" className="w-full max-w-lg mx-auto rounded-2xl shadow-2xl border-4 border-white cursor-pointer" whileHover={{
            scale: 1.03
          }} transition={{
            type: 'spring',
            stiffness: 300
          }} data-id="element-117" />
          </a>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="text-lg md:text-xl text-gray-600 font-medium mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-118">
          📚 Todo lo que necesitás en un solo lugar: actividades visuales,
          ejercicios progresivos, caligrafías, comprensión lectora y mucho más.{' '}
          <span className="font-bold text-gray-800" data-id="element-119">
            Descargá, imprimí y empezá hoy mismo.
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-8 mb-10 text-lg font-bold text-gray-800" data-id="element-120">
          <span className="flex items-center gap-2" data-id="element-121">
            <span className="text-green-500 text-2xl" data-id="element-122">✅</span> Sin pantallas
          </span>
          <span className="hidden sm:block text-gray-300" data-id="element-123">•</span>
          <span className="flex items-center gap-2" data-id="element-124">
            <span className="text-green-500 text-2xl" data-id="element-125">✅</span> Sin estrés
          </span>
          <span className="hidden sm:block text-gray-300" data-id="element-126">•</span>
          <span className="flex items-center gap-2" data-id="element-127">
            <span className="text-green-500 text-2xl" data-id="element-128">✅</span> Sin "tareas
            eternas"
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} data-id="element-129">
          <CTAButton subtext="✅ Garantía de satisfacción de 7 días" data-id="element-130" />
        </motion.div>
      </div>
    </section>;
}